<template>
  <div class="bmi-box">
    <table class="bmi-table">
      <tr v-for="oTr in 6" :key="oTr">
        <td v-for="oTd in 12" :key="oTd"></td>
      </tr>
    </table>
    <div class="bmi-top flex justify-between align-center">
      <div class="title_3 theme_01">{{ $t.BodyMass }}</div>
      <div class="text_4 theme_02">{{ $t[bmiName] }} - {{ bmi }}</div>
    </div>
    <div class="bmi">
      <div class="bmi-scale flex justify-between align-center">
        <div v-for="item in bmiScaleList" :key="item">{{ item }}</div>
      </div>
      <div class="bmi-symbol" :style="{ left: progressValue + '%' }">
        <div class="bim-label text_4" :class="{ 'min-label': bmi < 10, 'max-label': bmi > 37 }">
          {{ $t.You }}{{ bmi }}
        </div>
        <div class="bim-point"><i></i></div>
      </div>
      <div class="bmi-bar"></div>
      <div class="bmi-name  flex justify-between">
        <span v-for="(item, index) in $t.bmiNameList" :key="index" :class="{ 'bmi-text': index == bmiIndex }">{{ item
          }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bmi",
  props: {
    bmi: {
      default: 78,
    },
    bmiName: {
      default: ""
    },
    bmiIndex: {
      default: 0
    },
    progressNumber: {
      default: 0
    }
  },
  data() {
    return {
      bmiScaleList: [15, 18.5, 25, 30, 40],
      progressValue: 0,
      bmiColors: {
        underweight: '#F24822',
        normal: "#34C759",
        overweight: "#FFA800",
        obese: "#F24822"
      }
    };
  },
  mounted() {
    setTimeout(() => {
      this.progressValue = this.progressNumber
    }, 100);

  }
};
</script>
<style scoped lang="scss">
.bmi-box {
  position: relative;
  padding: 15px 8% 0 6%;
  height: 100%;
  overflow: hidden;

  .bmi-table {
    position: absolute;
    left: 0;
    right: 0;
    top: -20px;
    bottom: -10px;
    z-index: 1;
    width: 100%;
    height: calc(100% + 30px);
    border-collapse: collapse;
    border-spacing: 0;
    border: none;
    opacity: 0.7;

    td {
      border: 1px dashed #eee;
    }
  }

  .bmi-top {
    width: calc(100% + 12px);
    margin-bottom: 40px;

    .underweight {
      color: #F24822;
    }
  }

  .bmi {
    box-sizing: border-box;
    position: relative;
    z-index: 9;

    .bmi-scale {
      width: calc(100% + 12px);
      margin-bottom: 5px;
      font-size: 14px;

    }

    .bmi-symbol {
      position: absolute;
      left: 0;
      top: 18px;
      transition: all ease-out 1s;

      .bim-label {
        padding: 0 10px;
        position: absolute;
        left: 50%;
        bottom: 50px;
        margin-left: -35px;
        height: 30px;
        line-height: 32px;
        text-align: center;
        color: var(--theme_03);
        background: var(--theme_01);
        border-radius: 4px;
        cursor: pointer;
        white-space: nowrap;
      }

      .min-label {
        margin-left: -27px !important;
      }

      .max-label {
        margin-left: -50px;
      }

      .bim-point {
        position: relative;
        top: -6px;
        width: 25px;
        height: 25px;
        background: var(--theme_03);
        border-radius: 50%;
        box-shadow: 0 0 5px #c3c2c2;

        i {
          position: absolute;
          display: block;
          left: 50%;
          margin-left: -6px;
          top: -23px;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 10px solid var(--theme_01);
        }
      }

      .bim-point::after {
        position: absolute;
        left: 10px;
        top: -19px;
        z-index: -1;
        height: 20px;
        width: 2px;
        content: "";
        background-color: var(--theme_01);

      }
    }

    .bmi-bar {
      width: calc(100% + 12px);
      height: 6px;
      border-radius: 16px;
      background-image: linear-gradient(to right, #81c24d, #ffdd7a, #f75836);
    }

    .bmi-name {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 24px;
      margin-top: 15px;
      color: var(--theme_02);
      font-size: 15px;

      .bmi-text {
        color: var(--theme_01);
      }
    }
  }
}

@media (max-width: 576px) {
  .bmi-box {
    padding: 8px 8% 0 6%;

    .bmi .bmi-symbol {
      .bim-label {
        min-width: 77px;
        margin-left: -35px;
        height: 25px;
        line-height: 25px;
        bottom: 50px;
      }

      .max-label {
        margin-left: -65px;
      }
    }

    .bmi-top {
      margin-bottom: 35px;
    }

    .bmi .bmi-name {
      font-size: 10px;
    }
  }
}
</style>
